import request from '@/utils/request'

export function findModuleInventories(params) {
  return request({
    url: `/module_inventories`,
    method: 'get',
    params
  })
}

// 模组入库记录
export function findModuleInventoryImportRecords(params) {
  return request({
    url: `/module_inventories/import_records`,
    method: 'get',
    params
  })
}

// 模组入库
export function importModuleInventories(data) {
  return request({
    url: `/module_inventories/import`,
    method: 'post',
    data
  })
}

// 模组重新入库
export function reImportModuleInventories(data) {
  return request({
    url: `/module_inventories/re_import`,
    method: 'post',
    data
  })
}

// 导出库存模组
export function exportModuleInventories(data) {
  return request({
    url: `/module_inventories/export`,
    method: 'post',
    data
  })
}

// 删除库存模组
export function destroyModuleInventories(data) {
  return request({
    url: `/batch_operations/module_inventories`,
    method: 'delete',
    data
  })
}

// 模组型号库存统计
export function findModuleInventoryStatistics(params) {
  return request({
    url: `/module_inventories/statistics`,
    method: 'get',
    params
  })
}

// 模组型号库存按固件版本汇总
export function findModuleInventoryFirmwareVersionStatistics(moduleModelId) {
  return request({
    url: `/module_inventories/statistics/${moduleModelId}/firmware_versions`,
    method: 'get'
  })
}

// 模组库存告警设置
export function setModuleInventoryAlarm(moduleModelId, data) {
  return request({
    url: `/module_inventories/statistics/${moduleModelId}/set_alarm`,
    method: 'post',
    data
  })
}
